import api from '../httpClient';

export interface FlowImportData {
  flow_id?: number;
  flow_name?: string;
  flow_description?: string;
  frequency?: string;
  is_quiz?: boolean;
  passing_score_percentage?: number;
  max_attempts?: number;
  estimated_duration_minutes?: number;
  replace_existing_media?: boolean;
  append_mode?: boolean;
}

export const buildFlowImportFormData = (data: FlowImportData & { csv_file: File }) => {
  const formData = new FormData();
  formData.append('csv_file', data.csv_file);

  if (data.flow_id) {
    formData.append('flow_id', data.flow_id.toString());
  }
  if (data.flow_name) {
    formData.append('flow_name', data.flow_name);
  }
  if (data.flow_description !== undefined) {
    formData.append('flow_description', data.flow_description.trim());
  }
  if (data.frequency) {
    formData.append('frequency', data.frequency);
  }
  if (typeof data.is_quiz === 'boolean') {
    formData.append('is_quiz', data.is_quiz ? 'true' : 'false');
  }
  if (data.passing_score_percentage !== undefined) {
    formData.append('passing_score_percentage', data.passing_score_percentage.toString());
  }
  if (data.max_attempts !== undefined) {
    formData.append('max_attempts', data.max_attempts.toString());
  }
  if (data.estimated_duration_minutes !== undefined) {
    formData.append('estimated_duration_minutes', data.estimated_duration_minutes.toString());
  }
  if (typeof data.replace_existing_media === 'boolean') {
    formData.append('replace_existing_media', data.replace_existing_media ? 'true' : 'false');
  }
  if (typeof data.append_mode === 'boolean') {
    formData.append('append_mode', data.append_mode ? 'true' : 'false');
  }

  return formData;
};

export const importFlowFromCsv = (data: FlowImportData & { csv_file: File }) => {
  const formData = buildFlowImportFormData(data);

  return api
    .post('/api/admin/content-import/import-flow-from-csv/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error('Flow import request failed:', error.message);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      throw error;
    });
};

export const importFlowFromDrive = (data: FlowImportData & { drive_url: string }) =>
  api
    .post('/api/admin/content-import/import-flow-from-drive/', {
      drive_url: data.drive_url,
      flow_id: data.flow_id,
      flow_name: data.flow_name,
      flow_description: data.flow_description,
      frequency: data.frequency,
      is_quiz: data.is_quiz,
      passing_score_percentage: data.passing_score_percentage,
      max_attempts: data.max_attempts,
      estimated_duration_minutes: data.estimated_duration_minutes,
      replace_existing_media: data.replace_existing_media,
      append_mode: data.append_mode,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error('Flow import from Drive request failed:', error.message);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      throw error;
    });

export const exportFlow = (flowId: number) =>
  api.get('/api/admin/content-import/export-flow/', {
    params: { flow_id: flowId },
    responseType: 'blob',
  });
